import { Component, OnInit, Input,OnDestroy, OnChanges } from '@angular/core';
import { Icons } from '@vex/icons/icons';
import { ResizeHorizontalService } from '@vex/helper/resize-horizontal';
import { AdvanceDataTypeService } from '@vex/services/advance-data-type.service';
import { MatDialog } from '@angular/material/dialog';
import { SecurityPopupComponent } from '../dynamic-template-review/security-popup/security-popup.component';
import { scaleIn400ms } from '@vex/animations/scale-in.animation';
import { scaleFadeIn400ms } from '@vex/animations/scale-fade-in.animation';
import { stagger40ms } from '@vex/animations/stagger.animation';
import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { fadeInRight400ms } from '@vex/animations/fade-in-right.animation';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'elastic-complex-table-view',
  templateUrl: './complex-table-view.component.html',
  styleUrls: ['./complex-table-view.component.scss'],
  animations: [scaleIn400ms, fadeInRight400ms, stagger40ms, fadeInUp400ms, scaleFadeIn400ms]
})
export class ComplexTableViewComponent extends Icons implements OnInit,OnChanges,OnDestroy {
  @Input() data: any;
  @Input() displayName: any;
  @Input() name: any;
  @Input() columns: any;
  @Input() isGetComplexAttribute: boolean = false;
  applyResizeColumnsTableId: any[] = [];
  tabHeight: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private resizeHorizontalService: ResizeHorizontalService,
    private dialog: MatDialog,
    private advanceDataTypeService: AdvanceDataTypeService) {
    super();
  }

  getRowAttribute(data) {
    if(this.isGetComplexAttribute) {
      return data._ComplexAttributes;
    }
    return this.columns;
  }

  getHeight(extra: number = 0) {
    let navHeight = 37;
    const height_inner = (window.innerHeight - navHeight - extra).toString();
    return height_inner + 'px';
  }

  getAttributeValue(data, attribute) {
    let value: any;
    if (data) {
      value = data[attribute.Name];
      if (data['ddLable_' + attribute.Name]) {
        value = data['ddLable_' + attribute.Name] || data[attribute.Name];
      }
      if(!attribute.AttributeType) {
        this.advanceDataTypeService.getAttributeDataTypeForValue(attribute, true);
      }
      if(!attribute.AttributeType) {
        return 'N/A';
      }
      if (attribute.AttributeType.BaseType == 'int' && value == 0) {
        return '0';
      }
      if (attribute.AttributeType.BaseType == 'bool' && value == false) {
        return 'false';
      }
      if (attribute.AttributeType.Name?.toLowerCase() == 'password' && value) {
        return '******';
      }
      if (attribute.DisplayType == 2) {
        if(attribute.IsVisible) {
          let values = [];
          if (data[attribute.Name + '_data']) {
            let val = data[attribute.Name + '_data'];
            val = JSON.parse(val);
            let keys = Object.keys(val);
            keys.forEach((key) => {
              let options = val[key];
              values = [...values, ...options];
            });
          }
          if (attribute.IsList) {
            value = [];
            value = values.map((x) => {
              return x.Label;
            });
            if (value) {
              value = value.join(', ');
            }
          } else {
            value = values[0]?.Label || data[attribute.Name];
          }
        } else {
          return 'N/A';
        }
      }
    }

    return value ? value : 'N/A';
  }

  resizeTables() {
    var tables = document.getElementsByClassName('resizable');
    for (var i = 0; i < tables.length; i++) {
      if (this.applyResizeColumnsTableId.findIndex((x) => x == tables[i].id && tables[i].id == (this.name + '_table')) == -1) {
        this.applyResizeColumnsTableId.push(tables[i].id);
        this.resizeHorizontalService.resizableGrid(tables[i]);
      }
    }
    this.callUntilTableResizeAble();
  }

  callUntilTableResizeAble() {
    let scope = this;
    if (this.applyResizeColumnsTableId.findIndex((x) => x == this.name + '_table') == -1) {
      setTimeout(() => {
        scope.resizeTables();
      }, 500);
    }
  }

  ViewTableFullScreen() {
    this.dialog.open(SecurityPopupComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      width: '95%',
      disableClose: true,
      data: {
        data: this.data,
        name: this.name,
        columns: this.columns,
        isGetComplexAttribute: this.isGetComplexAttribute,
        displayName: this.displayName
      }
    }).afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((r: any) => {
      });;
    
  }

  ngAfterViewInit() {
    this.resizeTables();
  }

  getColumnLength() {
    return this.columns?.filter(type =>
      type.DataGeneratedBy=='User' || (type.DataGeneratedBy=='CSP' && type.IsParentProperty == true)
    ) || [];
  }

  columnLength: any = [];
  ngOnInit() {
    this.tabHeight = this.getHeight(200);
    this.columnLength = this.getColumnLength();
  }
  
  rowAttributes: any[] = [];
  ngOnChanges(): void {
  if (this.data && this.data.length) {
    this.rowAttributes = this.isGetComplexAttribute
      ? this.data[0]._ComplexAttributes || []
      : this.columns?.filter(type =>
          type.DataGeneratedBy == 'User' ||
          (type.DataGeneratedBy == 'CSP' && type.IsParentProperty)
        ) || [];

    this.data.forEach(item => {
      this.rowAttributes.forEach(attr => {
        item['display_' + attr.Name] = this.getAttributeValue(item, attr);
      });
    });
  }
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  trackByListId(index: number, list: any) {
    return list.Id || list.Name;
  }
}
